/* eslint-disable require-jsdoc */
import { EventBus } from '@v4/common/utils/event-bus';

export default async function HeaderOfferLpThreeSteps(loadLanguage = false) {
    if (loadLanguage) {
        const { loadDefaultLanguage } = await import('@v4/locale/async');
        await loadDefaultLanguage();
    }

    const register = (await import('@v4/common/directives')).default;
    const Vue = (await import('vue')).default;

    register(Vue);
    const headerOfferLpThreeStepsInstance = new Vue({
        el: '#header-dkpromo-three-steps',
        name: 'HeaderOfferLpThreeSteps',
        components: {
            DkIcon: () => ({
                component: import(/* webpackChunkName: "DkIcon-vue" */ '@v4/common/components/atoms/DkIcon.vue'),
            }),
        },
        data() {
            return {
                steps: [1, 2, 3],
                currentStep: 1,
            };
        },
        mounted() {
            EventBus.$on('DkPromoThreeSteps:set-two-steps', this.setSteps);
            EventBus.$on('DkPromoThreeSteps:next-step', this.handleNextStep);
        },
        beforeDestroy() {
            EventBus.$off();
        },
        methods: {
            setSteps() {
                this.steps.pop();
            },
            handleNextStep(step) {
                this.currentStep = step;
            },
        },
    });

    return headerOfferLpThreeStepsInstance;
}
